/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_TestInputs */

const en_portal_scanner_test = /** @type {(inputs: Portal_Scanner_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const de_portal_scanner_test = /** @type {(inputs: Portal_Scanner_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const fr_portal_scanner_test = /** @type {(inputs: Portal_Scanner_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const es_portal_scanner_test = /** @type {(inputs: Portal_Scanner_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const it_portal_scanner_test = /** @type {(inputs: Portal_Scanner_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const nl_portal_scanner_test = /** @type {(inputs: Portal_Scanner_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const pl_portal_scanner_test = /** @type {(inputs: Portal_Scanner_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const fi_portal_scanner_test = /** @type {(inputs: Portal_Scanner_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const da_portal_scanner_test = /** @type {(inputs: Portal_Scanner_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

const sv_portal_scanner_test = /** @type {(inputs: Portal_Scanner_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

/**
* | output |
* | --- |
* | "Test" |
*
* @param {Portal_Scanner_TestInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_test = /** @type {((inputs?: Portal_Scanner_TestInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_TestInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_test(inputs)
	if (locale === "fr") return fr_portal_scanner_test(inputs)
	if (locale === "es") return es_portal_scanner_test(inputs)
	if (locale === "it") return it_portal_scanner_test(inputs)
	if (locale === "nl") return nl_portal_scanner_test(inputs)
	if (locale === "pl") return pl_portal_scanner_test(inputs)
	if (locale === "fi") return fi_portal_scanner_test(inputs)
	if (locale === "da") return da_portal_scanner_test(inputs)
	if (locale === "sv") return sv_portal_scanner_test(inputs)
	return en_portal_scanner_test(inputs)
});